<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

    <!-- {{formSchema}} -->
    <div
      v-if="formSchema.loan_no"
      class="text-xs-left text-sm-left text-md-left"
      style="position: absolute; top:8px;"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-chip account_tree color="success" label outline v-on="on">
            <v-icon color="success">account_tree</v-icon>
            &nbsp; Loan No : {{ formSchema.loan_no }}</v-chip
          >
        </template>
        <span>Loan No : {{ formSchema.loan_no }}</span>
      </v-tooltip>
    </div>

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md class="pb-0">
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Sub Project Name *"
                item-text="sub_project_name"
                v-model="sub_project_object"
                :items="SubProjectIdList"
                return-object
                :rules="[(v) => !!v || 'Sub project name is required !']"
                required
                @input="setProjectCode(sub_project_object)"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="(!formSchema.id > 0)">
              <v-text-field
                label="Sub Project Short Name *"
                v-model="formSchema.sub_project_short"
                :rules="[(v) => !!v || 'Sub project Short name is required !']"
              ></v-text-field>
            </v-flex>

            <input type="hidden" v-model="formSchema.sub_project_id" />

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Currency *"
                v-model="formSchema.transaction_currency"
                :items="['BDT', 'USD']"
                :rules="[(v) => !!v || 'Currency is required !']"
                required
                @change="CurrencyChange(1)"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                :label="`Loan Amount (Hins : ${ActiveLoanAmount})`"
                v-model="formSchema.loan_amount"
                :rules="[decimal]"
                @keyup="LoanAmount(formSchema.loan_amount)"
                @input="LoanAmount(formSchema.loan_amount)"
                type="number"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Loan Period (In Month) *"
                v-model="formSchema.loan_period_in_month"
                :rules="[
                  (v) => !!v || 'Loan period (in month) is required !',
                  lng11,
                  decimal,
                ]"
                required
                type="number"
                @keyup="loanCalculate"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Repayment Period (In Month) *"
                v-model="formSchema.repayment_period_in_month"
                @keyup="loanCalculate"
                :rules="[(v) => !!v || 'Currency is required !',lng11, decimal]"
                @input="ChangeInstType"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Grace Period (In Month)"
                v-model="formSchema.grace_period_in_month"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <!-- label="Interest Rate" -->
              <v-text-field
                label="Interest Rate *"
                v-model="formSchema.interest_rate"
                :rules="[(v) => !!v || 'Field is required !', lng11, decimal]"
                required
                @input="changeInterest"
                type="number"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Installment Type *"
                item-text="installment_type"
                item-value="id"
                v-model="formSchema.installment_type_id"
                :items="InstallmentTypeIdList"
                @change="ChangeInstType"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="No. of Installment"
                v-model="formSchema.no_of_installment"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Interest Pay in Grace Period"
                v-model="formSchema.interestPay_InGracePeriod"
                :items="['With Interest Payment', 'Without Interest Payment']"
                :rules="[
                  (v) => !!v || 'Interest pay in grace period is required !',
                ]"
                @input="changeGracePeriod(formSchema.interestPay_InGracePeriod)"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Grace Period In With Interest (In Month)"
                v-model="formSchema.sub_grace_period_in_month"
                :readonly="PeriodTrue"
                @input="addInstNumber(formSchema.sub_grace_period_in_month)"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Interest Type *"
                v-model="formSchema.interest_type"
                :items="['Fixed', 'Variable']"
                :rules="[(v) => !!v || 'Interest type is required !']"
                required
                @input="changeInterestType(formSchema.interest_type)"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Interest Rate Reset Frequency(By Month)"
                v-model="formSchema.interest_by_month"
                :items="['Fixed', 'Variable']"
                :rules="intByMonthRules"
                type="number"
                :disabled="
                  formSchema.interest_type == 'Variable' ? false : true
                "
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="PFI Name *"
                item-text="short_name"
                item-value="id"
                v-model="formSchema.pfi_info_id"
                :items="PfiInfoIdList"
                :rules="[(v) => !!v || 'PFI info is required !']"
                required
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Overdue Interest Rate"
                v-model="formSchema.overdue_interest_rate"
                type="number"
                :rules="[lng11, decimal]"
              ></v-text-field>
            </v-flex>


            <v-flex xs12 sm6 md6 style="position:relative">
              <v-text-field
                style="width:75%; display: inline-block;"
                :label="`Sub-Project IDA amount (Hins:${sub_pro_IDA_amount})`"
                :rules="[decimal]"
                v-model="formSchema.loan_amount_ida"
                @input="changeLoanAmount(formSchema.loan_amount_ida, 'IDA')"
                :readonly="
                  formSchema.re_schedule_no > 0 || formSchema.reset_no > 0
                "
                type="number"
                :disabled="idaDisable"
              ></v-text-field>
              <!-- @input="changeLoanAmount(formSchema.loan_amount_ida,'IDA')" -->
              <input
                type="number"
                readonly
                v-model="formSchema.loan_amount_ida_percent"
                style="border:1px solid #ccc; width:18%; display: inline-block;"
              />%
            </v-flex>

            <v-flex xs12 sm6 md6 style="position:relative">
              <v-text-field
                style="width:75%; display: inline-block;"
                :label="`Sub-Project GoB amount (Hins:${sub_pro_GoB_amount})`"
                v-model="formSchema.loan_amount_gob"
                :rules="[decimal]"
                @input="changeLoanAmount(formSchema.loan_amount_gob, 'GoB')"
                :readonly="
                  formSchema.re_schedule_no > 0 || formSchema.reset_no > 0
                "
                type="number"
                :disabled="gobDisable"
              ></v-text-field>
              <!-- @input="changeLoanAmount(formSchema.loan_amount_gob,'GoB')"   -->
              <input
                type="number"
                readonly
                v-model="formSchema.loan_amount_gob_percent"
                style="border:1px solid #ccc; width:18%; display: inline-block;"
              />%
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="PFI Account (In BB)"
                v-model="formSchema.pfi_account_in_bb"
                :rules="[lng30]"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Commitment Charge"
                v-model.number="formSchema.commitment_charge"
                type="number"
                :rules="[lng11, decimal]"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Disbursement Account IDA"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.disbursement_account_ida"
                :items="RePaymentAccountNoGobList"
                :readonly="formSchema.loan_amount_ida < 1"
              ></v-autocomplete>
              <!-- @input="ChangeDisbAcc('disbursement_account_gob')" -->
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Disbursement Account GoB"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.disbursement_account_gob"
                :items="RePaymentAccountNoGobList"
                :readonly="formSchema.loan_amount_gob < 1"
              ></v-autocomplete>
              <!-- @input="ChangeDisbAcc('disbursement_account_ida')" -->
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Repayment Account"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.re_payment_account_no_ida"
                :items="RePaymentAccountList"
              ></v-autocomplete>
              <!-- @input="ChangeDisbAcc('re_payment_account_no_gob')" -->
            </v-flex>


            

            <!-- <v-flex xs12 sm6 md6>              
              <v-autocomplete
                label="Sub Project Name"
                item-text="sub_project_name"
                item-value="id"
                v-model="formSchema.sub_project_id"
                :items="SubProjectIdList"
                :rules="[v => !!v || 'Sub project name is required !']"
                required
                @change="setProjectCode(formSchema.sub_project_id)"
              ></v-autocomplete>
            </v-flex> -->

            <!-- <v-flex xs12 sm6 md6>              
              <v-autocomplete
              label="Currency"                
              v-model="formSchema.sub_project_currency"
              :items="['BDT','USD']"
              :rules="[v => !!v || 'Currency is required !']"
              @change="CurrencyChange()"
              required                
              ></v-autocomplete>
            </v-flex> -->

            

            <!-- <v-flex xs12 sm6 md6>
            <DatePicker
            :key="formSchema.id"
            :inputData="{index:1,fieldName:'loan_date', fieldValue:formSchema.loan_date, label:'Loan Date', required:'1'}"
            @setValue="setDateValue"
            ></DatePicker>
          </v-flex> -->

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Loan Date"
                v-model="formSchema.loan_date"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Re-Schedule No"
                v-model="formSchema.re_schedule_no"
                type="number"
                :rules="[lng11]"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Re-Schedule Date"
                v-model="formSchema.re_schedule_date"
                type="number"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Reset No"
                v-model="formSchema.reset_no"
                type="number"
                :rules="[lng11]"
                readonly
              ></v-text-field>
            </v-flex>

            

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Reset Date"
                v-model="formSchema.reset_date"
                readonly
              ></v-text-field>
            </v-flex>

            <!-- <v-flex xs12 sm6 md6>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'reset_date', fieldValue:formSchema.reset_date, label:'Reset Date', required:''}"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex> -->

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Sub Project Location"
                v-model="formSchema.sub_project_location"
                readonly
              ></v-text-field>
            </v-flex>

            

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Client Name"
                v-model="formSchema.client_name"
                readonly
              ></v-text-field>
            </v-flex>

            <!-- <v-flex xs12 sm6 md6>
              <v-text-field label="Sector Name" v-model="formSchema.sector_name" readonly></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Sub Sector Name" v-model="formSchema.sub_sector_name" readonly></v-text-field>
            </v-flex> -->

            

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Agreement Date"
                v-model="formSchema.agreement_date"
                readonly
              ></v-text-field>
            </v-flex>

            

            <!-- <v-flex xs12 sm6 md2>
              <v-text-field              
              label="Period"
              v-model="formSchema.sub_grace_period_in_month"              
              :readonly="PeriodTrue"
              ></v-text-field>
            </v-flex> -->

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Grace Period Interest Rate"
                v-model="formSchema.grace_period_interest_rate"
                type="number"
                :rules="[lng11, decimal]"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Sector Name"
                v-model="formSchema.sector_name"
                readonly
              ></v-text-field>
            </v-flex>

            

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Sub Sector Name"
                v-model="formSchema.sub_sector_name"
                readonly
              ></v-text-field>
            </v-flex>

            

            
            

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Repayment Start Date"
                v-model="formSchema.repayment_start_date"
                type="text"
                readonly
              ></v-text-field>

              <!-- <DatePicker
                :key="formSchema.id"
                :inputData="{
                  index: 1,
                  fieldName: 'repayment_start_date',
                  fieldValue: formSchema.repayment_start_date,
                  label: 'Repayment Start Date',
                  required: '0',
                }"
                ref="setRange"
                @setValue="setDateValue"
              ></DatePicker> -->
            </v-flex>

            

            <!-- <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Re Payment Account No GoB"
                item-text="eco_account_name"
                item-value="id"
                v-model="formSchema.re_payment_account_no_gob"
                :items="RePaymentAccountNoGobList"
                @input="ChangeDisbAcc('re_payment_account_no_ida')"
              ></v-autocomplete>
            </v-flex>  -->

            <!-- <v-flex xs12 sm6 md6>
              <v-checkbox v-model="formSchema.status" label="Status" :value="isActiveVal"></v-checkbox>
            </v-flex> -->

            <v-flex xs12 sm6 md12>
              <v-textarea
                label="Remarks"
                v-model="formSchema.remarks"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-btn
        v-if="
          formSchema.id > 0 &&
            (formSchema.reset_no > 0 || formSchema.re_schedule_no > 0)
        "
        color="success"
        @click="nextStep(3)"
      >
        Repayment
      </v-btn>

      <span
        v-if="formSchema.totalSchedule > 0"
        style="margin-left: 10px;font-size: 16px; border: 1px solid dimgray;color: dimgray;padding: 5px 10px;font-weight: bold;"
      >
        Repayment has already been created
      </span>

      <!--    <span v-if="formSchema.totalSchedule > 0" style="color:green">       
        <v-alert :value="true" type="info" >
         Repayment has already been created
       </v-alert>
      </span> -->

      <v-spacer></v-spacer>
      <!-- v-if="!formSchema.totalSchedule && formSchema.status < 2" -->
      <v-btn
        v-if="formSchema.status < 2 && saveBtn"
        color="primary"
        :disabled="buttonDisable"
        @click = "saveLoanProfile"
      >
        Save & Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
      <v-btn v-if="formSchema.status < 2" color="secondary" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="primary" @click="nextStep(2)">
        Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      valid: true,
      e1: 0,
      isActiveVal: 0,
      saveBtn: true,
      PeriodTrue: true,
      idaDisable: false,
      gobDisable: false,
      buttonDisable: false,
      checkboxVal: 1,
      loan_id: sessionStorage.getItem("loan_id"),

      intByMonthRules: [],

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: "",
      },

      queryData: {
        loanId: 0,
        sub_project_id: 0,
        transaction_currency: "",
      },

      locationList: [
        "Dhaka",
        "Khulna",
        "Rajshahi",
        "Rangpur",
        "Sylhet",
        "Barisal",
      ],

      rules: {
        decimalOnly: (value) => {
          const pattern = /^\d+(\.\d)?\d*$/;
          return pattern.test(value) || "Not a valied number";
        },
      },
      loanNoObject: {
        Project_code: "",
        SectorShortName: "",
        PFI_ShortName: "",
        TotalLoanCount: 0,
      },

      ActiveLoanAmount: "",

      SubProjectIdList: [],
      PfiInfoIdList: [],
      InstallmentTypeIdList: [],
      DisbursementAccountIdaList: [],
      DisbursementAccountGobList: [],
      RePaymentAccountNoIdaList: [],
      RePaymentAccountNoGobList: [],
      RePaymentAccountList: [],

      sub_project_object: "",

      sub_pro_IDA_amount: 0,
      sub_pro_GoB_amount: 0,

      formSchema: {
        id: 0,
        loan_no: "",
        totalSchedule: "",
        loan_date: "",
        re_schedule_no: 0,
        re_schedule_date: "",
        reset_no: 0,
        reset_date: "",
        sub_project_location: "",
        client_name: "",

        client_id: "",
        location_id: "",
        sub_sector_id: "",
        sector_id: "",

        agreement_date: "",
        loan_amount: "",
        loan_amount_ida: "",
        loan_amount_gob: "",
        loan_amount_ida_percent: "",
        loan_amount_gob_percent: "",
        commitment_charge: 0,
        repayment_start_date: "",
        loan_period_in_month: "",
        repayment_period_in_month: "",
        no_of_installment: "",
        interest_type: "",

        sub_project_id: "",
        sub_project_short: "",

        interest_by_month: "0",
        interest_rate: "",
        overdue_interest_rate: "",
        grace_period_in_month: "",
        interestPay_InGracePeriod: "Without Interest Payment",
        sub_grace_period_in_month: "",
        sector_name: "",
        sub_sector_name: "",
        pfi_account_in_bb: "",
        transaction_currency: "",
        status: "",
      },
    };
  },

  watch: {
    "formSchema.loan_date": function(val) {
      if (val !== null) {
        this.loanCalculate();
      }
    },
    "formSchema.grace_period_in_month": function(val) {
      let date = (this.formSchema.loan_date) ? this.formSchema.loan_date : this.formSchema.agreement_date;
      date = this.changeFormateYMD(date);
      date = new Date(date);
      let tempdate = date.setMonth(date.getMonth() + parseInt(val));
      let nextRePaymentdate = new Date(tempdate);
      nextRePaymentdate = nextRePaymentdate.toJSON().substring(0, 10);
      nextRePaymentdate = this.changeFormateDMY(nextRePaymentdate);
      this.formSchema.repayment_start_date = nextRePaymentdate;
      let data = {
        fieldName: "repayment_start_date",
        fieldValue: null,
        index: 1,
        label: "Repayment Start Date",
        required: "0",
        value: nextRePaymentdate,
      };
      this.setDateValue(data);
      console.log(this.formSchema.repayment_start_date);
    },
  },

  created() {
    /*v-model="formSchema.interest_type"
    :items="['Fixed','Variable']"*/

    this.dateFormating();
    commonService
      .getAllData("get-dropdown-data-for-load-profile")
      .then((res) => {
        this.SubProjectIdList = res.SubProjectIdList;
        this.PfiInfoIdList = res.PfiInfoIdList;
        this.InstallmentTypeIdList = res.InstallmentTypeIdList;
        this.RePaymentAccountNoGobList = res.AccountInfo;
        this.RePaymentAccountList = res.RePaymentAccountList;
      });

    if (this.loan_id) {
      this.loadData();
    }
  },

  methods: {
    // Installment Number increment with 
    addInstNumber(sub_grace){
      let formSchema = this.formSchema;
      var grace = formSchema.grace_period_in_month;
      let instTypeVal = formSchema.installment_type_id;
      if (instTypeVal > 0) {
        let dividedVal = this.InstallmentTypeIdList.filter(function(a) {
          return a.id === instTypeVal;
        })[0];
        var exit_inst_number = Number(formSchema.repayment_period_in_month) / Number(dividedVal.year_divided);
        if( formSchema.interestPay_InGracePeriod == 'With Interest Payment' && sub_grace > 0){
          var diffgrace = Number(grace) - Number(sub_grace);
          if(diffgrace > 0){
            var extra_intall = Number(diffgrace) / Number(dividedVal.year_divided);
            this.formSchema.no_of_installment = (Number(exit_inst_number) + Number(extra_intall))
          }else{
            var subMonth = Number(sub_grace) / Number(dividedVal.year_divided)
            this.formSchema.no_of_installment = (Number(exit_inst_number) + Number(subMonth))
          }
        }else{
          this.formSchema.no_of_installment = exit_inst_number;
        }
      }
    },
    loadData() {
      commonService
        .getAllDataById(this.loan_id, "loan-profile-data-by-id")
        .then((res) => {
          if (res.data) {
            //console.log('res.data', res.data);

            this.formSchema = res.data;

            //console.log('this.formSchema', res.data.repayment_start_date);

            /* this.formSchema.repayment_start_date = this.changeFormateDMY(
            this.formSchema.repayment_start_date
          );         

         this.formSchema.loan_date = this.changeFormateDMY(
          this.formSchema.loan_date
          );
         this.formSchema.re_schedule_date = this.changeFormateDMY(
          this.formSchema.re_schedule_date
          );
         this.formSchema.reset_date = this.changeFormateDMY(
          this.formSchema.reset_date
          );
         this.formSchema.agreement_date = this.changeFormateDMY(
          this.formSchema.agreement_date
          );*/

            this.dateFormating();

            this.$store.commit("SET_KEY_VALUE", this.formSchema.totalSchedule);

            this.sub_project_object = {
              id: res.data.sub_project_id,
              sub_project_name: res.data.sub_project_name,
              loan_amount: res.data.loan_amount,
              loan_amount_ida: res.data.loan_amount_ida,
              loan_amount_ida_percent: res.data.loan_amount_ida_percent,
              loan_amount_gob_percent: res.data.loan_amount_gob_percent,
              loan_amount_gob: res.data.loan_amount_gob,
              bdt_total: res.data.bdt_total,
              usd_total: res.data.usd_total,
            };

            sessionStorage.setItem("loan_s", btoa(res.data.status));

            this.CurrencyChange();
          }
        });
    },

    dateFormating() {
      let repayment_start_date = this.formSchema.repayment_start_date;
      this.formSchema.repayment_start_date =
        repayment_start_date != "0000-00-00"
          ? this.changeFormateDMY(repayment_start_date)
          : "";
      let loan_date = this.formSchema.loan_date;
      this.formSchema.loan_date =
        loan_date != "0000-00-00" ? this.changeFormateDMY(loan_date) : "";

      let re_schedule_date = this.formSchema.re_schedule_date;
      this.formSchema.re_schedule_date =
        re_schedule_date != "0000-00-00"
          ? this.changeFormateDMY(re_schedule_date)
          : "";

      let reset_date = this.formSchema.reset_date;
      this.formSchema.reset_date =
        reset_date != "0000-00-00" ? this.changeFormateDMY(reset_date) : "";

      let agreement_date = this.formSchema.agreement_date;
      this.formSchema.agreement_date =
        agreement_date != "0000-00-00"
          ? this.changeFormateDMY(agreement_date)
          : "";
    },

    saveLoanProfile() {
      if (this.$refs.form.validate()) {
        //button disale
        this.buttonDisable = true;
        //Data submission
        this.submitForm();
        // Re-enable after 3 seconds
        this.timeout = setTimeout(() => {
          this.buttonDisable = false
        }, 3000)
      }
    },

    submitForm() {
      this.$refs.loader.loaderEnabled();

      this.formSchema.loan_amount_gob = parseFloat(
        this.formSchema.loan_amount_gob
      );
      this.formSchema.loan_amount_ida = parseFloat(
        this.formSchema.loan_amount_ida
      );
      if (this.formSchema.loan_amount_ida && this.formSchema.loan_amount_gob) {
        this.formSchema.loan_amount =
          this.formSchema.loan_amount_ida + this.formSchema.loan_amount_gob;
      } else if (this.formSchema.loan_amount_gob) {
        this.formSchema.loan_amount = this.formSchema.loan_amount_gob;
      } else if (this.formSchema.loan_amount_ida) {
        this.formSchema.loan_amount = this.formSchema.loan_amount_ida;
      }
      let $this = this;
      let formSchema = this.formSchema;

      /*  formSchema.loan_no = formSchema.loan_date = this.changeFormateYMD(
        formSchema.loan_date
        );*/

      formSchema.loan_date = this.changeFormateYMD(formSchema.loan_date);
      formSchema.re_schedule_date = this.changeFormateYMD(
        formSchema.re_schedule_date
      );
      formSchema.reset_date = this.changeFormateYMD(formSchema.reset_date);

      formSchema.agreement_date = this.changeFormateYMD(
        formSchema.agreement_date
      );

      formSchema.repayment_start_date = this.changeFormateYMD(
        formSchema.repayment_start_date
      );

      formSchema.interest_rate = formSchema.interest_rate; //parseFloat(formSchema.interest_rate).toFixed(6);

      let functionName = "insertFormData";
      if (formSchema.id > 0) {
        functionName = "updateFormData";
      }

      //console.log('formSchema', formSchema);
      //return 0;

      commonService[functionName](formSchema, "loan-profile").then((res) => {
        //console.log('res', res);

        if (res.status == 1) {
          this.saveBtn = false;

          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.SnackbarVal.color = "success";

          sessionStorage.setItem("loan_id", res.data.id);
          this.formSchema.loan_no = res.data.loan_no;

          setTimeout(function() {
            $this.date_formate();
          }, 3000);
        } else {
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.SnackbarVal.color = "error";
        }
      });
    },

    date_formate() {
      let formSchema = this.formSchema;

      formSchema.financing_agreement_date = this.changeFormateDMY(
        formSchema.financing_agreement_date
      );
      formSchema.administration_agreement_date = this.changeFormateDMY(
        formSchema.administration_agreement_date
      );
      formSchema.project_approval_date = this.changeFormateDMY(
        formSchema.project_approval_date
      );
      formSchema.project_start_date = this.changeFormateDMY(
        formSchema.project_start_date
      );
      formSchema.agreement_date = this.changeFormateDMY(
        formSchema.agreement_date
      );
      formSchema.project_end_date = this.changeFormateDMY(
        formSchema.project_end_date
      );
      this.nextStep(2);
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if (data.fieldName == "loan_date") {
        this.formSchema.repayment_start_date = "";
        this.$refs.setRange.setRange(data.value);
      }
    },

    loanCalculate() {
      let formSchema = this.formSchema;
      let gMonth =
        Number(formSchema.loan_period_in_month) -
        Number(formSchema.repayment_period_in_month);
      formSchema.grace_period_in_month = gMonth;

      let dts = this.changeFormateDMY(formSchema.loan_date);
      let dateval = dts.split("/");
      if (gMonth > 0 && dateval[2] > 0 && dateval[1] > 0 && dateval[0] > 0) {
        let repStr_date = this.addMonths(
          new Date(dateval[2], dateval[1], dateval[0]),
          gMonth
        ).toString();

        formSchema.repayment_start_date = this.changeFormateDMY(repStr_date);
      }
    },

    changeGracePeriod(val) {
      console.log("val", val);
      if (val == "With Interest Payment") {
        this.PeriodTrue = false;
      } else {
        this.PeriodTrue = true;
        this.formSchema.sub_grace_period_in_month = '';
        this.formSchema.repayment_period_in_month = '';
      }
    },

    addMonths(date, months) {
      var d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() != d) {
        date.setDate(0);
      }

      let dts =
        date.getFullYear() +
        "-" +
        ("0" + date.getMonth()).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);

      let fieldObject = {
        index: 1,
        fieldName: "repayment_start_date",
        fieldValue: "formSchema.repayment_start_date",
        value: dts,
        label: "Repayment Start Date",
        required: "1",
      };

      this.$refs.setRange.setDateValue(fieldObject);

      return dts;
    },

    ChangeDisbAcc(emptyFieldName) {
      this.formSchema[emptyFieldName] = null;
    },

    ChangeInstType() {
      let instTypeVal = this.formSchema.installment_type_id;
      if (instTypeVal > 0) {
        let formSchema = this.formSchema;

        let dividedVal = this.InstallmentTypeIdList.filter(function(a) {
          return a.id === instTypeVal;
        })[0];

        formSchema.no_of_installment =
          Number(formSchema.repayment_period_in_month) /
          Number(dividedVal.year_divided);
      }
    },

    LoanAmount(amount) {
      let formSchema = this.formSchema;
      formSchema.loan_amount_ida = 0;
      formSchema.loan_amount_gob = 0;

      if (parseFloat(this.ActiveLoanAmount) < amount) {
        this.SnackbarVal.message =
          "The loan amount is not equal to the amount of sub-project";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        this.formSchema.loan_amount = 0.0;
      }
    },

    changeLoanAmount(val, forVal) {
      let formSchema = this.formSchema;

      let loanAmount = parseFloat(formSchema.loan_amount);
      let idaAmount = parseFloat(formSchema.loan_amount_ida);
      let gobAmount = parseFloat(formSchema.loan_amount_gob);

      let sub_pro_IDA_amount = this.sub_pro_IDA_amount;
      let sub_pro_GoB_amount = this.sub_pro_GoB_amount;

      if (formSchema.reset_no > 0 || formSchema.re_schedule_no > 0) {
        return 0;
      }

      if (loanAmount < 1) {
        this.SnackbarVal.message = "Loan amount is empty!";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        formSchema.loan_amount_ida = 0;
        formSchema.loan_amount_gob = 0;
        formSchema.loan_amount_ida_percent = 0;
        formSchema.loan_amount_gob_percent = 0;
        return 0;
      }

      if (idaAmount > sub_pro_IDA_amount || gobAmount > sub_pro_GoB_amount) {
        this.SnackbarVal.message = "Cross your loan amount!";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error";
        formSchema.loan_amount_ida = 0;
        formSchema.loan_amount_gob = 0;
        formSchema.loan_amount_ida_percent = 0;
        formSchema.loan_amount_gob_percent = 0;
        return 0;
      }

      /**
       * changed & write by majeed
       */
      // if(!idaAmount) {
      //   this.idaDisable = true
      // }
      // if(!gobAmount) {
      //   this.gobDisable = true
      // }

      // if (forVal == "IDA") {
      //   formSchema.loan_amount_gob = (loanAmount - idaAmount).toFixed(2);
      // }
      // if (forVal == "GoB") {
      //   formSchema.loan_amount_ida = (loanAmount - gobAmount).toFixed(2);
      // }
      //console.log('idaAmount =', formSchema.loan_amount_ida,  'gobAmount =', formSchema.loan_amount_gob);

      formSchema.loan_amount_ida_percent = (
        (parseFloat(formSchema.loan_amount_ida) * 100) /
        loanAmount
      ).toFixed(2);
      formSchema.loan_amount_gob_percent = (
        (parseFloat(formSchema.loan_amount_gob) * 100) /
        loanAmount
      ).toFixed(2);
    },

    CurrencyChange(setYes = "") {
      let formSchema = this.formSchema;
      let loanAmount = formSchema.loan_amount;

      let currency = formSchema.transaction_currency;

      //console.log('this.sub_project_object', this.sub_project_object);

      let query_Data = this.queryData;
      (query_Data.loanId = formSchema.id),
        (query_Data.sub_project_id = formSchema.sub_project_id),
        (query_Data.transaction_currency = formSchema.transaction_currency);

      commonService
        .getServerSideData(query_Data, "get-total-loan-amount")
        .then((res) => {
          //console.log('res.minusLoanAmount', res.minusLoanAmount);

          if (formSchema.reset_no < 1 && formSchema.re_schedule_no < 1) {
            console.log(res);
            let takeV = parseFloat(res.minusLoanAmount);

            let ida_val = res.sub_pro ? res.sub_pro.ida : "";
            let gob_val = res.sub_pro ? res.sub_pro.gob : "";

            if (ida_val) {
              // this.sub_pro_IDA_amount = ida_val - takeV;
              if (formSchema.id > 0) {
                this.sub_pro_IDA_amount =
                  ida_val - parseFloat(res.loan_amount_ida);

                formSchema.loan_amount_ida = formSchema.loan_amount_ida;
              } else {
                this.sub_pro_IDA_amount =
                  ida_val - parseFloat(res.loan_amount_ida);

                formSchema.loan_amount_ida = this.sub_pro_IDA_amount;
              }
            }
            if (gob_val) {
              // this.sub_pro_GoB_amount = gob_val - takeV;

              if (formSchema.id > 0) {
                this.sub_pro_GoB_amount =
                  gob_val - parseFloat(res.loan_amount_gob);
                formSchema.loan_amount_gob = formSchema.loan_amount_gob;
              } else {
                this.sub_pro_GoB_amount =
                  gob_val - parseFloat(res.loan_amount_gob);
                formSchema.loan_amount_gob = this.sub_pro_GoB_amount;
              }
            }

            // formSchema.loan_amount_ida = this.sub_pro_IDA_amount;
            // formSchema.loan_amount_gob = this.sub_pro_GoB_amount;

            if (currency == "USD") {
              //console.log('this.sub_project_object.usd_total', this.sub_project_object.usd_total);
              let pv = parseFloat(this.sub_project_object.usd_total);

              if (takeV >= pv) {
                this.SnackbarVal.message = "USD amount is not available!";
                this.SnackbarVal.snackbar = true;
                this.SnackbarVal.color = "error";
                formSchema.loan_amount = "";
                formSchema.loan_amount_ida = "";
                formSchema.loan_amount_gob = "";
                formSchema.loan_amount_ida_percent = "";
                formSchema.loan_amount_gob_percent = "";
                this.ActiveLoanAmount = 0;
                this.saveBtn = false;
              } else {
                var amountUSD = pv - takeV;
                if (setYes == 1) {
                  formSchema.loan_amount = amountUSD;

                  if (ida_val) {
                    formSchema.loan_amount_ida_percent = (
                      (ida_val * 100) /
                      pv
                    ).toFixed(3);
                  } else {
                    this.idaDisable = true;
                  }
                  if (gob_val) {
                    formSchema.loan_amount_gob_percent = (
                      (gob_val * 100) /
                      pv
                    ).toFixed(3);
                  } else {
                    this.gobDisable = true;
                  }
                }
                this.ActiveLoanAmount = amountUSD > 0 ? amountUSD : 0;
                this.saveBtn = true;
              }
            }

            if (currency == "BDT") {
              let pv = parseFloat(this.sub_project_object.bdt_total);

              if (takeV >= pv) {
                this.SnackbarVal.message = "BDT amount is not available!";
                this.SnackbarVal.snackbar = true;
                this.SnackbarVal.color = "error";
                formSchema.loan_amount = "";
                formSchema.loan_amount_ida = "";
                formSchema.loan_amount_gob = "";
                formSchema.loan_amount_ida_percent = "";
                formSchema.loan_amount_gob_percent = "";
                this.ActiveLoanAmount = 0;
                this.saveBtn = false;
              } else {
                var amountBDT = pv - takeV;
                console.log("BDT", amountBDT);
                if (setYes == 1) {
                  formSchema.loan_amount = amountBDT;
                  if (ida_val) {
                    formSchema.loan_amount_ida_percent = (
                      (ida_val * 100) /
                      pv
                    ).toFixed(3);
                  } else {
                    this.idaDisable = true;
                  }
                  if (gob_val) {
                    formSchema.loan_amount_gob_percent = (
                      (gob_val * 100) /
                      pv
                    ).toFixed(3);
                  } else {
                    this.gobDisable = true;
                  }
                }
                this.ActiveLoanAmount = amountBDT > 0 ? amountBDT : 0;
                this.saveBtn = true;
              }
            }
          }
        });
    },

    setProjectCode(subProjectObject) {
      let subProId = subProjectObject.id;
      this.formSchema.sub_project_id = subProId;

      this.formSchema.currency = "";
      this.formSchema.loan_amount = 0.0;
      this.ActiveLoanAmount = "0";

      this.CurrencyChange();

      let formSchema = this.formSchema;

      if (subProId) {
        let proInfo = this.SubProjectIdList.filter(function(val) {
          return val.id == subProId;
        })[0];

        //console.log('proInfo = ', proInfo);

        formSchema.location_id = proInfo.location_id;
        formSchema.sub_sector_id = proInfo.sub_sector_id;
        formSchema.sector_id = proInfo.sector_id;
        formSchema.client_id = proInfo.client_id;

        formSchema.client_name = proInfo.client_name;
        formSchema.sub_project_location = proInfo.location_name;
        formSchema.sector_name = proInfo.sector_name;
        formSchema.sub_sector_name = proInfo.sub_sector_name;

        formSchema.agreement_date = this.changeFormateDMY(
          proInfo.agreement_date
        );
      }
    },

    changeInterest() {
      let formSchema = this.formSchema;
      formSchema.overdue_interest_rate = formSchema.interest_rate;
      formSchema.grace_period_interest_rate = formSchema.interest_rate;
    },

    //Variable
    changeInterestType(val) {
      if (val == "Fixed") {
        this.intByMonthRules = [];
      } else {
        this.intByMonthRules.push(
          (v) => !!v || "Loan period (in month) is required !"
        );
        this.intByMonthRules.push(eval(this.decimal));
      }

      this.formSchema.interest_by_month = "0";
    },

    nextStep(stp) {
      this.$emit("emitForm1", stp);
    },

    previous() {
      this.$emit("emitForm1", 1);
    },

    close: function() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
  position: absolute !important;
  left: 37%;
}
</style>



// WEBPACK FOOTER //
// src/components/lending/loanProfile/step_forms/loanProfileForm.vue